"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reduxForm = require("redux-form");
var _APIcon = _interopRequireDefault(require("../APIcon"));
var _APInput = require("../APInput");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./APPasswordInput.css");
var _excluded = ["customClass"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var baseClass = 'ap-password-input';
var PasswordInput = /*#__PURE__*/function (_React$Component) {
  function PasswordInput(props) {
    var _this;
    _classCallCheck(this, PasswordInput);
    _this = _callSuper(this, PasswordInput, [props]);
    _defineProperty(_this, "handleClick", function () {
      _this.setState({
        reveal: !_this.state.reveal
      });
    });
    _defineProperty(_this, "renderIcon", function (bemClasses) {
      return /*#__PURE__*/_react["default"].createElement("span", {
        onClick: _this.handleClick,
        className: bemClasses('icon', {
          active: _this.state.reveal
        })
      }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
        name: 'eye'
      }));
    });
    _this.state = {
      value: '',
      reveal: false
    };
    return _this;
  }
  _inherits(PasswordInput, _React$Component);
  return _createClass(PasswordInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        customClass = _this$props.customClass,
        passedProps = _objectWithoutProperties(_this$props, _excluded);
      var bemClasses = (0, _cssClassesHelper.getBEMClasses)(baseClass, customClass);
      var iconComponent = this.renderIcon(bemClasses);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses()
      }, /*#__PURE__*/_react["default"].createElement(_APInput.InnerInput, _extends({
        customClass: customClass
      }, passedProps, {
        type: this.state.reveal ? 'text' : 'password',
        iconComponent: iconComponent
      })));
    }
  }]);
}(_react["default"].Component);
var APPasswordInput = function APPasswordInput(props) {
  return /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, _extends({
    name: props.name,
    component: PasswordInput
  }, props));
};
APPasswordInput.propTypes = {
  customClass: _propTypes["default"].string
};
var _default = exports["default"] = APPasswordInput;